import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-white/50 font-mono text-xs tracking-[0.3em]">LOADING...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role === "admin" && user.role !== "admin") return <Navigate to="/" replace />;
  if (role === "creator" && !["creator", "admin"].includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
